const { __ } = wp.i18n;
/**
 * Container block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Colour select", "uipress-lite"),
  moduleName: "uip-colour-select-input",
  description: __("Outputs a colour select input. For use with the form block", "uipress-lite"),
  group: "form",
  icon: "palette",
};
